// @ts-nocheck
import * as PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

/**
 * Render the passengers field skeleton
 *
 * @param {string} id - Component ID
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 * @return {JSX.Element} The the passengers field skeleton component
 */
const PassengersFieldSkeleton = ({ id, ...rest }) => {
  return (
    <Box
      id={id}
      data-testid='passenger-field-skeleton'
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '16px'
      }}
      {...rest}
    >
      <Box style={{ display: 'flex', justifyContent: 'end' }}>
        <Skeleton
          variant='rectangular'
          width={'197px'}
          height={42}
          sx={{
            marginBottom: '8px',
            borderRadius: '8px'
          }}
        />
      </Box>
      <Skeleton
        variant='rectangular'
        width={'100%'}
        height={52}
        sx={{ borderBottom: '1px solid #EAECF0', backgroundColor: '#f5f5f5' }}
      />
      {Array.from(new Array(6)).map((_, index) => (
        <Skeleton
          key={index}
          variant='rectangular'
          width={'100%'}
          height={75}
          sx={{ borderBottom: '1px solid #EAECF0', backgroundColor: '#f5f5f5' }}
        />
      ))}
    </Box>
  );
};

PassengersFieldSkeleton.propTypes = {
  id: PropTypes.string
};

export default PassengersFieldSkeleton;
